<template>
  <v-card flat>
    <v-card outline class="mt-10 py-4">
      <v-form v-if="!Edit">
        <v-card-title>Lägg till Moment</v-card-title>
        <v-text-field
          v-model="newElement"
          label="Moment"
          class="text-field mx-auto"
          append-icon="mdi-file-document-box-plus-outline"
        />
      </v-form>

      <v-card-actions>
        <v-col class="mx-auto px-auto text-center" cols="12" md="6">
          <v-btn v-if="!Edit" @click="clickAdd" type="submit" color="primary">Lägg till</v-btn>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-card>
</template>
<script>
// @group Common
// AddElement component
export default {
  name: 'AddElement',
  data: () => ({
    newElement: '',
    Edit: false
  }),
  props: {},
  methods: {    
    clickAdd() {
      // Fire addElementClick event
      // @arg The argument is string representing element 
      this.$emit('addElementClick', this.newElement)
      this.newElement = ''
    }    
  }
}
</script>
<style lang="scss">
.text-field {
  width: 90%;
}
</style>